import type { SpriteDefinition } from '@/render/spriteBaker';
import type { NpcId } from '@/data/npcs';
import { PALETTE } from '@/sprites/palette';

/**
 * The people, 16x16 on Katie's own grid.
 *
 * One standing frame each. A villager who is where the hour says and does not
 * walk does not need a walk cycle, and giving them one would promise movement
 * the schedule does not deliver.
 */

/**
 * Pell: broad hat, heavy coat, boots that have done some miles.
 *
 * Built on Katie's silhouette — same head height, same shoulder width, arms
 * and legs where hers are. A first pass gave him a solid ten-pixel coat and he
 * read as a crate standing next to the cart, which is a poor introduction for
 * the only other person in the world.
 */
const PELL: string[] = [
  '................',
  '..mmmmmmmmmmmm..',
  '..mmmmmmmmmmmm..',
  '....MMMMMMMM....',
  '....ssssssss....',
  '....sessesss....',
  '....ssssssss....',
  '.....ssssss.....',
  '...qqqwwwwqqq...',
  '...qQqwwwwqQq...',
  '...qQqwwwwqQq...',
  '...qqqwwwwqqq...',
  '..QQqqwwwwqqQQ..',
  '.....bb..bb.....',
  '.....bb..bb.....',
  '.....bb..bb.....',
];

/**
 * Mira: hair tied back, a leather apron over a smith's shirt.
 *
 * Katie's silhouette again, and deliberately not Pell's: he is a wide hat and
 * a coat, she is a narrow head and a dark apron. Two people who read alike at
 * this size are one person standing in two places.
 */
const MIRA: string[] = [
  '................',
  '................',
  '.....kkkkkk.....',
  '....khhhhhhk....',
  '....ssssssss....',
  '....sessesss....',
  '....ssssssss....',
  '.....ssssss.....',
  '...rrmmmmmmrr...',
  '...rmMMMMMMmr...',
  '...rmMMMMMMmr...',
  '...rmMMMMMMmr...',
  '...rrmmmmmmrr...',
  '.....bb..bb.....',
  '.....bb..bb.....',
  '.....bb..bb.....',
];

export const NPC_SPRITES = {
  pell: { name: 'npc-pell', rows: PELL, palette: PALETTE },
  mira: { name: 'npc-mira', rows: MIRA, palette: PALETTE },
} as const satisfies Record<NpcId, SpriteDefinition>;

export type NpcSpriteKey = keyof typeof NPC_SPRITES;
